import React from 'react';
import { useNavigate } from "react-router-dom";
import { process } from "@progress/kendo-data-query";
import { Layout } from '../components/MasterPage/Layout';
import { UserListGrid } from '../components/Grid/UserListGrid';
import { DateFormater } from "../services/DateFormater"
import useFetchWithMsal from '../services/useFetchWithMsal';
import { apiRoutes } from '../services/apiRoutes';
import { DeleteUserModal } from '../components/Modals/DeleteUserModal';
import { ContextMenu } from '../components/ContextMenu';
export function UserList(props) {
	const usertypes = {
		SpheraAdmin: 1,
		TenentAdmin: 2,
		Tenent: 3,
		Portal: 4
	};
	const { adjustForTimezone } = DateFormater();
	let navigate = useNavigate();
	const [success, setSuccess] = React.useState(false);
	const [error, setError] = React.useState(false);
	const [errorMessage, setErrorMessage] = React.useState("");
	const [currentUserId, setcurrentUserId] = React.useState(0);
	const [downloadGrid, setdownloadGrid] = React.useState(false);
	const [showColumnSelect, setshowColumnSelect] = React.useState(false);
	const [buttonsConfig, setbuttonsConfig] = React.useState([]);
	const [showDeleteUserModal, setshowDeleteUserModal] = React.useState(false);
	const offSet = React.useRef({ left: 0, top: 0 });
	const userMenuClick = (userId, e) => {
		setcurrentUserId(userId)
		e.preventDefault();
		offSet.current = {
			left: e.clientX,
			top: e.clientY,
		};
		setshowContext(true);
	};

	const isIaUserPage = (window.location.pathname === '/manageUsers');
	const [showContext, setshowContext] = React.useState(false);
	const [users, setusers] = React.useState([]);
	const [originalUsers, setoriginalUsers] = React.useState([]);
	const [dataState, setDataState] = React.useState({ skip: 0, take: 25 });
	const [pending, setPending] = React.useState(false);
	const [showAll, setshowAll] = React.useState(false);
	const [dataResult, setDataResult] = React.useState(
		process(users, dataState)
	);
	const dataStateChange = (event) => {
		setDataResult(process(users, event.dataState));
		setDataState(event.dataState);
	};

	const { execute, result } = useFetchWithMsal({
		scopes: props.loginConfig.protectedResources.apiDocumentList.scopes.read,
	});
	const deleteUser = async (userId) => {
		await execute("DELETE", apiRoutes.users.delete(userId));
	}
	const handleShowAllUsersChange = () => {
		setshowAll(!showAll);

		if (showAll) {
			let filteredUsers = originalUsers.filter(x => x.hasIaPassword === "Yes");
			setusers(filteredUsers);
			setDataResult(process(filteredUsers, dataState));
		}
		else {
			setusers(originalUsers);
			setDataResult(process(originalUsers, dataState));
		}
	}
	const toggleDeleteUserModal = () => {
		setshowDeleteUserModal(!showDeleteUserModal);
	};

	const menuItems = [props.localizations.Delete];
	const rowContextClick = (e) => {
		if (e.item.text === props.localizations.Delete)
			toggleDeleteUserModal();
	};

	const getData = () => {
		setPending(true);
		let userTypeId = isIaUserPage ? usertypes.Tenent : usertypes.Portal;
		execute("GET", `${apiRoutes.users.get}?localeId=${props.languageValue.localeId}&userTypeId=${userTypeId}`)
			.then(json => {
				if (json != null) {
					let newusers = json.map(x => {
						if (x.timestampCreate != null) {
							x.timestampCreateDisplay = adjustForTimezone(x.timestampCreate.substring(0, x.timestampCreate.indexOf("+")), props.customer.TimezoneId);
							x.timestampCreate = adjustForTimezone(x.timestampCreate.substring(0, x.timestampCreate.indexOf("+")), props.customer.TimezoneId);
						}
						return x;
					});
					let filteredUsers = newusers.filter(x => x.hasIaPassword === "Yes");


					setusers(filteredUsers);
					setoriginalUsers(newusers);
					setDataResult(process(filteredUsers, dataState));
					setPending(false);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	const submitDeleteUser = async () => {
		setPending(true);
		setshowDeleteUserModal(!showDeleteUserModal);
		deleteUser(currentUserId).then(async () => {
			setSuccess(true);
			setTimeout(function () {
				setSuccess(false);
			}, 5000);
			await getData();
		})
			.catch((error) => {
				setError(true);
				setErrorMessage(props.localizations.DeleteUserError);
			});
	};

	const [gotData, setgotData] = React.useState(false);
	React.useEffect(() => {
		if (gotData || result == null)
			return;
		setgotData(true);
	}, [execute, window.location.pathname]);

	React.useEffect(() => {
		if (props.currentTenent.CustomerId == null)
			return;
		let requiredRole = isIaUserPage ? props.currentTenent.IsIAUserAdmin : props.currentTenent.IsEditCustomerPortalUser
		if (!requiredRole)
			navigate("/NoPermissions");
		if (gotData)
			getData();
	}, [gotData, window.location.pathname, props.currentTenent.CustomerId]);

	React.useEffect(() => {
		let target = isIaUserPage ? "/manageUser/0" : "/manageCpUser/0"
		if (props.localizations.IncludeActive != null)
			setbuttonsConfig([
				{
					type: 'primary',
					text: props.localizations.AddUser,
					onClick: () => { navigate(target); }
				},
				{
					type: 'secondary',
					icon: 'icon-ui-general-libraries',
					tooltip: props.localizations.Columns,
					position: "top",
					onClick: () => { setshowColumnSelect(true); }
				},
				{
					type: 'secondary',
					icon: 'icon-ui-general-download',
					tooltip: props.localizations.Download,
					position: "top",
					onClick: () => { setdownloadGrid(true); }
				}
			]);
	}, [props.localizations, window.location.pathname]);

	return (
		<Layout versionNumber={props.versionNumber} success={success} setSuccess={setSuccess} error={error} setError={setError} errorMessage={errorMessage} buttonsConfig={buttonsConfig} currentTenent={props.currentTenent} localizations={props.localizations} changeLanguage={props.changeLanguage} languageValue={props.languageValue} >
			<div>
				<UserListGrid isIaUserPage={isIaUserPage} userMenuClick={userMenuClick} customer={props.customer} dateFormatId={props.customer.dateFormatId} localizations={props.localizations}
					pending={pending} users={users} dataState={dataState} dataResult={dataResult} dataStateChange={dataStateChange}
					showColumnSelect={showColumnSelect} downloadGrid={downloadGrid} setdownloadGrid={setdownloadGrid} setshowColumnSelect={setshowColumnSelect} handleShowAllUsersChange={handleShowAllUsersChange} showAll={showAll} />

				<ContextMenu menuItems={menuItems} offSet={offSet} rowContextClick={rowContextClick} showContext={showContext} setshowContext={setshowContext} />

				<DeleteUserModal localizations={props.localizations} showDeleteUserModal={showDeleteUserModal} toggleDeleteUserModal={toggleDeleteUserModal} submitDeleteUser={submitDeleteUser} />
			</div>
		</Layout>
	);
}
